import './clicktale-snippet';
import epic from './epic';

export default epic;
